module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 30
// module chunks = 107